import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { YtbesprechungPageComponent } from './page/ytbesprechung-page/ytbesprechung-page.component';
import { YtbesprechungDetailsGuard } from './guard/ytbesprechung-details.guard';

const routes: Routes = [
  {
    path: ':id/:title',
    component: YtbesprechungPageComponent,
    canActivate: [YtbesprechungDetailsGuard]
  },
  {
    path: ':id',
    canActivate: [YtbesprechungDetailsGuard],
    pathMatch: 'full',
    component: YtbesprechungPageComponent,
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class YtbesprechungRoutingModule {
}
